import {
    Box,
    Divider,
    IconAlertFilled,
    IconBoxFilled,
    IconBoxLocationFilled,
    IconCancelFilled,
    IconCheckedFilled,
    IconSmsFilled,
    IconWaitClockFilled,
    Stack,
    Text1,
    Text3,
    skinVars,
} from '@telefonica/mistica';
import React from 'react';
import { getFormatDate } from '../../utils/dataTransformation/dateConversions';
import './index.scss';
import { IStepperTimeLineOrders } from '../../models/Tracking.interfaces';

export const StepperBulletTimeLine: React.FC<{ bullets: IStepperTimeLineOrders[] }> = ({
    bullets,
}: {
    bullets: IStepperTimeLineOrders[];
}) => {
    const getIconBullet = (description: string) => {
        switch (description) {
            case 'EN PREPARACION':
                return <IconCheckedFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'FINALIZADO SIN ENTREGA':
                return <IconCancelFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'ALTA TRANSPORTE':
                return <IconBoxFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'RECEPCION TRANSPORTE':
                return <IconBoxFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'PENDIENTE':
                return <IconWaitClockFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'ENVIADO SMS':
                return <IconSmsFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'EN REPARTO':
                return <IconBoxLocationFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'INCIDENCIA':
                return <IconAlertFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'ENTRREGADO':
                return <IconCheckedFilled size={20} color={skinVars.colors.controlActivated} />;
            case 'NO ENTRREGADO':
                return <IconCancelFilled size={20} color={skinVars.colors.controlActivated} />;
            default:
                return <IconCheckedFilled size={20} color={skinVars.colors.controlActivated} />;
        }
    };

    return (
        <>
            {bullets.reverse().map((task: IStepperTimeLineOrders, index: number) => {
                const { description, date, time } = task;
                const t = time.split(':');
                return (
                    <Box key={index}>
                        <div className={`stepper-bullet-timeLine  ${index === bullets?.length - 1 ? 'last' : ''}`}>
                            <div className='stepper-bullet-timeLine-container'>
                                <div className='stepper-bullet-icon'>
                                    {getIconBullet(description)}
                                    <div
                                        className='stepper-bullet-timeLine-container-line'
                                        style={{ display: 'block', background: skinVars.colors.controlActivated }}
                                    ></div>
                                </div>
                                <Stack space={0}>
                                    <div
                                        className='stepper-bullet-timeLine-container-title'
                                        style={{ paddingTop: index !== 0 ? '5px' : '' }}
                                    >
                                        <Text3 regular color={skinVars.colors.feedbackInfoBackground}>
                                            {description === 'RECEPCION TRANSPORTE'
                                                ? 'RECEPCIÓN TRANSPORTE'
                                                : description === 'EN PREPARACION'
                                                ? 'EN PREPARACIÓN'
                                                : description}
                                        </Text3>
                                    </div>
                                    <div className='stepper-bullet-timeLine-container-date'>
                                        <Text1 medium color={skinVars.colors.neutralMedium}>
                                            {getFormatDate(date, 'DD de MM')} a las {t[0]}:{t[1]}
                                        </Text1>
                                    </div>
                                    <div className='stepper-bullet-divider'>
                                        {index !== bullets.length - 1 ? <Divider></Divider> : null}
                                    </div>
                                </Stack>
                            </div>
                        </div>
                    </Box>
                );
            })}
        </>
    );
};
export default StepperBulletTimeLine;
